import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { storeSchema, type StoreInput } from '../routes/stores.schema';

export function StoreFormDialog(props: {
  open: boolean; onClose: () => void; onSubmit: (d: StoreInput) => void; warehouses: { id: string; name: string }[];
}) {
  const { register, handleSubmit, formState: { errors } } = useForm<StoreInput>({ resolver: zodResolver(storeSchema) });
  if (!props.open) return null;
  return (
    <div role="dialog" aria-modal="true" className="fixed inset-0 bg-black/40 flex items-center justify-center">
      <form onSubmit={handleSubmit(props.onSubmit)} className="bg-white rounded p-6 w-96 space-y-3">
        <h2 className="text-lg font-bold text-primary">Create store</h2>
        <label className="block">Name<input {...register('name')} className="mt-1 w-full border rounded p-2" /></label>
        {errors.name && <p className="text-sm text-accent">{errors.name.message}</p>}
        <label className="block">Address<input {...register('address')} className="mt-1 w-full border rounded p-2" /></label>
        {errors.address && <p className="text-sm text-accent">{errors.address.message}</p>}
        <label className="block">GSTIN<input {...register('gstin')} className="mt-1 w-full border rounded p-2" /></label>
        <label className="block">Default warehouse
          <select {...register('default_warehouse_id')} className="mt-1 w-full border rounded p-2">
            <option value="">— none —</option>
            {props.warehouses.map((w) => <option key={w.id} value={w.id}>{w.name}</option>)}
          </select>
        </label>
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={props.onClose}>Cancel</button>
          <button type="submit" className="rounded bg-primary px-4 py-2 text-white">Save</button>
        </div>
      </form>
    </div>
  );
}
